import { render } from "./notice.vue?vue&type=template&id=1b1f94ac"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=1b1f94ac&lang=css"
script.render = render

export default script